module.exports = __webpack_public_path__ + "img/thumbnail_GreaterRhea_m_leucistic.ac98bdca.png";